import { defineComponent as r, openBlock as l, createBlock as a, unref as p, mergeProps as m, withCtx as u, createElementVNode as e } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ r({
  name: "IconEmojiNeutral",
  __name: "IconEmojiNeutral",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (i, t) => (l(), a(p(c), m(n, { "view-box": "0 0 24 24" }), {
      default: u(() => [...t[0] || (t[0] = [
        e("path", { d: "M9.5 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", { d: "M16.509 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-7.877 4C8.282 14 8 14.336 8 14.75s.283.75.632.75h6.736c.35 0 .632-.336.632-.75S15.717 14 15.368 14H8.632" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
